(() => {
  const root = document.querySelector("[data-dock]");
  if (!root) return;
  if (root.dataset.dockInit === "true") return;
root.dataset.dockInit = "true";

  const panel = root.querySelector("[data-dock-panel]");
  const tabsEl = root.querySelector("[data-dock-tabs]");
  const gridEl = root.querySelector("[data-dock-grid]");
  const jsonEl = root.querySelector("[data-dock-menu-json]");
  const dockButtons = [...root.querySelectorAll("[data-dock-item]")];


  if (!panel || !tabsEl || !gridEl || !jsonEl || !dockButtons.length) {
   
    document.documentElement.setAttribute("data-dock-init", "missing");
    return;
  }

  let data;
  try {
    data = JSON.parse(jsonEl.textContent || "{}");
  } catch (e) {
    document.documentElement.setAttribute("data-dock-init", "badjson");
    return;
  }

  document.documentElement.setAttribute("data-dock-init", "ok");

  const isTouch = matchMedia("(hover: none)").matches;
  let pinnedOpen = false;

  const GRID_MODE_HANDLES = new Set([
    "rental-solutions",
  ]);

  function assetIconUrl(handle) {
 
    const base = window.Shopify?.routes?.root || "/";
    return handle;
  }

  
  const assetsBase = (() => {
    const probe = document.createElement("img");
    probe.src = root.dataset.assetsProbe || "";
 
    return "";
  })();

  function iconSrc(handle) {

    const template = root.dataset.iconTemplate; // ex: "https://cdn.../icon-__HANDLE__.svg"
    if (!template) return "";
    return template.replace("__HANDLE__", handle);
  }

  function setActiveDock(btn) {
    dockButtons.forEach(b => {
      b.setAttribute("aria-expanded", b === btn ? "true" : "false");
    });
  }

  function openPanel() {
    panel.classList.add("is-open");
    panel.setAttribute("aria-hidden", "false");
  }

function closePanel() {
  pinnedOpen = false;
  panel.classList.remove("is-open");
  panel.setAttribute("aria-hidden", "true");

  dockButtons.forEach(b => {
    b.setAttribute("aria-expanded", "false");
  });

}

function renderTabs(item) {
  tabsEl.innerHTML = "";
  const children = item.children || [];
  const isBespokeTabsOnly = !GRID_MODE_HANDLES.has(item.handle);

  // BESPOKE: tabs viram links e o ativo vem da URL atual
  if (isBespokeTabsOnly) {
    const currentPath = window.location.pathname.replace(/\/$/, "");

    children.forEach((child) => {
      const a = document.createElement("a");
      const childPath = (child.url || "#").replace(/\/$/, "");
      const isActive = childPath === currentPath;

      a.className = "dock-tab" + (isActive ? " is-active" : "");
      a.textContent = child.title || "";
      a.href = child.url || "#";
      a.setAttribute("role", "tab");

      tabsEl.appendChild(a);
    });

    tabsEl.style.display = children.length ? "flex" : "none";
    return;
  }

  // caso normal: tabs em botão
  children.forEach((child, idx) => {
    const tab = document.createElement("button");
    tab.type = "button";
    tab.className = "dock-tab" + (idx === 0 ? " is-active" : "");
    tab.textContent = child.title || "";

    tab.addEventListener("mouseenter", () => setActiveTab(item, idx));
    tab.addEventListener("focus", () => setActiveTab(item, idx));
    tab.addEventListener("click", () => setActiveTab(item, idx));

    tabsEl.appendChild(tab);
  });

  tabsEl.style.display = children.length ? "flex" : "none";
}


  function renderGrid(list) {
    gridEl.innerHTML = "";


    (list || []).forEach(link => {
      const a = document.createElement("a");
      a.className = "dock-card";
      a.href = link.url || "#";

      const icon = document.createElement("div");
      icon.className = "dock-icon";

      const img = document.createElement("img");
      img.alt = link.title || "";
      img.loading = "lazy";
      img.src = iconSrc(link.handle || "");
      img.onerror = () => { img.remove(); };

      icon.appendChild(img);

      const label = document.createElement("div");
      label.className = "dock-label";
      label.textContent = link.title || "";

      a.appendChild(icon);
      a.appendChild(label);
      gridEl.appendChild(a);
    });
  }

  function setActiveTab(parentItem, idx) {
    const tabs = [...tabsEl.querySelectorAll(".dock-tab")];
    tabs.forEach((t, i) => t.classList.toggle("is-active", i === idx));

    const tabItem = (parentItem.children || [])[idx];
    const third = (tabItem && tabItem.children && tabItem.children.length)
      ? tabItem.children
      : (parentItem.children || []);

    renderGrid(third);
  }

function onDockEnter(btn) {
  if (pinnedOpen) return;

  dockButtons.forEach(b => {
    b.setAttribute("aria-expanded", "false");
  });

  const searchPanel = root.querySelector("[data-dock-search-panel]");
  if (searchPanel) {
    searchPanel.classList.remove("is-open");
    searchPanel.setAttribute("aria-hidden", "true");
    const searchTrigger = root.querySelector("[data-search-trigger]");
    if (searchTrigger) searchTrigger.setAttribute("aria-expanded", "false");
  }

  const handle = btn.dataset.handle;
  const item = (data.items || []).find(x => x.handle === handle) || null;
  if (!item) return;

  const hasChildren = Array.isArray(item.children) && item.children.length > 0;
  if (!hasChildren) {
    closePanel();
    return;
  }

  if (!GRID_MODE_HANDLES.has(item.handle)) {
    panel.classList.add("is-bespoke-mode");
  } else {
    panel.classList.remove("is-bespoke-mode");
  }

  setActiveDock(btn);
  renderTabs(item);

  if (!GRID_MODE_HANDLES.has(item.handle)) {
    gridEl.innerHTML = "";
    gridEl.style.display = "none";
    openPanel();
    return;
  }

  gridEl.style.display = "grid";

  const firstTab = (item.children || [])[0];
  const third = (firstTab && firstTab.children && firstTab.children.length)
    ? firstTab.children
    : (item.children || []);

  renderGrid(third);
  openPanel();
}


function onDockClick(btn) {
  clearTimeout(closeTimer);

  const handle = btn.dataset.handle;
  const item = (data.items || []).find(x => x.handle === handle) || null;
  if (!item) return;

  const hasChildren = Array.isArray(item.children) && item.children.length > 0;

  if (!hasChildren) {
    pinnedOpen = false;
    closePanel();
    if (item.url) window.location.href = item.url;
    return;
  }

  // se clicou no mesmo botão já aberto, fecha
  const alreadyActive = btn.getAttribute("aria-expanded") === "true" && panel.classList.contains("is-open");
  if (alreadyActive && pinnedOpen) {
    closePanel();
    return;
  }

  pinnedOpen = true;

  if (!GRID_MODE_HANDLES.has(item.handle)) {
    panel.classList.add("is-bespoke-mode");
  } else {
    panel.classList.remove("is-bespoke-mode");
  }

  dockButtons.forEach(b => {
    b.setAttribute("aria-expanded", "false");
  });

  setActiveDock(btn);
  renderTabs(item);

  if (!GRID_MODE_HANDLES.has(item.handle)) {
    gridEl.innerHTML = "";
    gridEl.style.display = "none";
    openPanel();
    return;
  }

  gridEl.style.display = "grid";

  const firstTab = (item.children || [])[0];
  const third = (firstTab && firstTab.children && firstTab.children.length)
    ? firstTab.children
    : (item.children || []);

  renderGrid(third);
  openPanel();
}




dockButtons.forEach(btn => {
 
  if (!isTouch) {
    btn.addEventListener("mouseenter", () => onDockEnter(btn));
    btn.addEventListener("focus", () => {
  if (!pinnedOpen) onDockEnter(btn);
});
  }


  btn.addEventListener("click", (e) => {

    e.preventDefault();
    onDockClick(btn);
  });
});



  

  let closeTimer;
 function scheduleClose(e) {
  clearTimeout(closeTimer);

  if (pinnedOpen) return;

  const to = e && e.relatedTarget;
  if (to && (panel.contains(to) || root.contains(to))) return;

  closeTimer = setTimeout(closePanel, 180);
}
  function cancelClose() {
    clearTimeout(closeTimer);
  }

  if (!isTouch) {
    root.addEventListener("mouseleave", scheduleClose);
    root.addEventListener("mouseenter", cancelClose);

    panel.addEventListener("mouseenter", cancelClose);
    panel.addEventListener("mouseleave", scheduleClose);
  }


  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closePanel();
  });

 
  document.addEventListener("click", (e) => {
    if (!panel.classList.contains("is-open")) return;
    if (!root.contains(e.target) && !panel.contains(e.target)) closePanel();
  });
})();


document.addEventListener('DOMContentLoaded', () => {
  const dockCart = document.querySelector('[data-dock-cart]');
  if (!dockCart) return;

  dockCart.addEventListener('click', (e) => {
    e.preventDefault();

    const themeTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

    if (themeTrigger) {
      themeTrigger.click(); // abre o side cart do tema
    } else {
      // fallback caso o tema mude ou não exista drawer
      window.location.href = '/cart';
    }
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const dockCountEl = document.querySelector('[data-cart-count]');
  if (!dockCountEl) return;

  const setDockCount = (n) => {
    const count = Number(n) || 0;
    dockCountEl.textContent = count;

    // Se você quiser esconder parênteses quando 0, dá pra tratar aqui também
    // (opcional) ex: adicionar classe no botão
    const dockCartBtn = dockCountEl.closest('[data-dock-cart]');
    if (dockCartBtn) dockCartBtn.classList.toggle('is-empty', count === 0);
  };

  // A) Fallback universal: lê o bubble do header e espelha no dock
  const headerBubbleCount =
    document.querySelector('[data-testid="cart-bubble"]') || // no seu HTML existe isso
    document.querySelector('[ref="cartBubbleCount"]');

  if (headerBubbleCount) {
    // seta inicial
    setDockCount(headerBubbleCount.textContent);

    // observa mudanças (quando o tema atualiza sem reload)
    const mo = new MutationObserver(() => {
      setDockCount(headerBubbleCount.textContent);
    });

    mo.observe(headerBubbleCount, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  } else {
    // Se não encontrar bubble, tenta buscar via /cart.js (Shopify padrão)
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => setDockCount(cart.item_count))
      .catch(() => {});
  }

  // B) Escuta eventos comuns (alguns temas disparam isso)
  const refreshFromCartJs = () => {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => setDockCount(cart.item_count))
      .catch(() => {});
  };

  // Eventos que alguns temas usam
  ['cart:updated', 'cart:change', 'cart:refresh', 'product:added'].forEach((evt) => {
    document.addEventListener(evt, refreshFromCartJs);
  });

  // C) Quando o drawer abrir, também força sync (seguro)
  const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
  cartTrigger?.addEventListener('click', () => {
    // dá um micro delay pra pegar o valor já atualizado
    setTimeout(() => {
      if (headerBubbleCount) setDockCount(headerBubbleCount.textContent);
      else refreshFromCartJs();
    }, 50);
  });
});



(function () {
  const dock = document.querySelector('.dock');
  if (!dock) return;

  const bespokeBtn = dock.querySelector('.dock__item[data-handle="bespoke-solutions"]');
  const panel = document.querySelector('.dock-panel'); // painel único

  if (!bespokeBtn || !panel) return;

  function syncBespokeMode() {
    const isOpen = bespokeBtn.getAttribute('aria-expanded') === 'true';
    if (isOpen) panel?.classList.add('is-bespoke-mode');
  }

  syncBespokeMode();

  const obs = new MutationObserver(syncBespokeMode);
  obs.observe(bespokeBtn, { attributes: true, attributeFilter: ['aria-expanded'] });
})();

(function () {
  const dock = document.querySelector('[data-dock]');
  if (!dock) return;

  const bespokePanel = dock.querySelector('.dock-panel');
  if (!bespokePanel) return;

  const dockBtns = [...dock.querySelectorAll('[data-dock-item]')];

  function setPanelPosition(btn) {
    if (!bespokePanel.classList.contains('is-bespoke-mode')) return;

    const btnRect = btn.getBoundingClientRect();
    const panelWidth = bespokePanel.getBoundingClientRect().width || 350;
    const gutter = 10;

    let left = btnRect.left;
    left = Math.max(gutter, Math.min(left, window.innerWidth - panelWidth - gutter));
    bespokePanel.style.left = `${left}px`;
    bespokePanel.style.bottom = `${window.innerHeight - btnRect.top + gutter}px`;
  }

  function clearPanelPosition() {
    bespokePanel.style.left = '';
    bespokePanel.style.bottom = '';
  }

  dockBtns.forEach(btn => {
    btn.addEventListener('mouseenter', () => requestAnimationFrame(() => setPanelPosition(btn)));
    btn.addEventListener('click', () => requestAnimationFrame(() => setPanelPosition(btn)));
  });

  const obs = new MutationObserver(() => {
    if (bespokePanel.getAttribute('aria-hidden') === 'true' ||
        !bespokePanel.classList.contains('is-bespoke-mode')) clearPanelPosition();
  });
  obs.observe(bespokePanel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });

  window.addEventListener('resize', () => {
    const active = dockBtns.find(b => b.getAttribute('aria-expanded') === 'true');
    if (active) setPanelPosition(active);
  });
  window.addEventListener('scroll', () => {
    const active = dockBtns.find(b => b.getAttribute('aria-expanded') === 'true');
    if (active) setPanelPosition(active);
  }, { passive: true });
})();